import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessCargaMasivaLeads } from '../utils/gestionCampanaAccess'

/** Acceso a Carga masiva de leads (solo Administrador). */
const RequireCargaMasivaLeadsAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessCargaMasivaLeads(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireCargaMasivaLeadsAccess
